module.exports = __webpack_public_path__ + "static/media/icon-check-square.a8a1bfcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-check-square.svg
// module id = 1848
// module chunks = 0